// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"95711af5","23":"0c23a889","260":"b12e3984","343":"4b63833c","382":"11dca86e","446":"f65d72e2","488":"1f658d63","507":"79106e1b","725":"63b314b5","746":"8c84e1f5","923":"00c77262","928":"7de2fd21"}[chunkId] + ".chunk.js";
};